// =============================================================================
// features/configuracoes/comercial/WindowPreview.tsx — Preview da janela de
// contato NO FUSO CONFIGURADO (nunca o fuso do navegador — ver contactWindowMath.ts).
// =============================================================================

import * as React from 'react';

import { Badge } from '../../../components/ui/Badge';

import { isWithinWindowAt, weekdaysLabel, zonedWallTime } from './contactWindowMath';

interface WindowPreviewProps {
  timezone: string;
  days: number[];
  startTime: string;
  endTime: string;
}

export function WindowPreview({
  timezone,
  days,
  startTime,
  endTime,
}: WindowPreviewProps): React.JSX.Element {
  // Recalcula a cada minuto — o preview reflete "agora" no fuso configurado.
  const [now, setNow] = React.useState(() => new Date());
  React.useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const wall = zonedWallTime(now, timezone);

  if (!wall) {
    return (
      <div
        role="alert"
        className="flex items-center gap-2 rounded-sm px-3 py-2"
        style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger)' }}
      >
        <span className="font-sans text-danger" style={{ fontSize: 'var(--text-xs)' }}>
          Fuso horário inválido — não é possível calcular o preview.
        </span>
      </div>
    );
  }

  const open = days.length > 0 && isWithinWindowAt(wall, { days, startTime, endTime });

  return (
    <div
      className="flex flex-col gap-2 rounded-sm px-4 py-3"
      style={{ background: 'var(--bg-elev-2)', border: '1px solid var(--border)' }}
    >
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <span className="font-sans font-semibold text-ink" style={{ fontSize: 'var(--text-sm)' }}>
          {days.length > 0
            ? `${weekdaysLabel(days)} · ${startTime}–${endTime}`
            : 'Nenhum dia selecionado'}
        </span>
        <Badge variant={open ? 'success' : 'neutral'}>
          {open ? 'Aberta agora' : 'Fechada agora'}
        </Badge>
      </div>
      <span className="font-mono text-ink-3" style={{ fontSize: 'var(--text-xs)' }}>
        Agora em {timezone}: {wall.time}
      </span>
    </div>
  );
}
